import {faCaretUp} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import type {NumberIncrementStepperProps} from '@chakra-ui/react';
import {forwardRef, NumberIncrementStepper as ChakraNumberIncrementStepper} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const NumberIncrementStepper = forwardRef<NumberIncrementStepperProps, 'div'>(({children, ...rest}, ref) => (
  <ChakraNumberIncrementStepper {...rest} ref={ref}>
    {children || <FontAwesomeIcon icon={faCaretUp} />}
  </ChakraNumberIncrementStepper>
));
